
// src/screens/CompletarRegistroScreen.js
import React, { useState } from 'react';
// eslint-disable-next-line no-unused-vars
import { doc, getDoc, updateDoc } from 'firebase/firestore';
// eslint-disable-next-line no-unused-vars
import { IoLogOutOutline } from 'react-icons/io5';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

function CompletarRegistroScreen() {
  const [codigoActivacion, setCodigoActivacion] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { completarRegistroSocial, currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (e) {
      console.error(e);
      alert("Error al salir");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await completarRegistroSocial(codigoActivacion);
      // Forzar navegación al Home
      navigate('/');
    } catch (err) {
      if (err.message.includes("activación inválido")) {
        setError("El código de activación es incorrecto.");
      } else {
        setError('Error al completar el registro.');
      }
      console.error(err);
      setLoading(false); // ¡Importante! Re-habilita si falla
    }
  };

  return (
    // ... (el JSX/HTML de esta pantalla no cambia) ...
    <div className="form-container" style={{ maxWidth: '450px' }}>
      <h1 className="form-header">Completar Registro</h1>
      <p style={{ textAlign: 'center', marginBottom: '20px' }}>
        ¡Bienvenido, {currentUser?.displayName}! Solo un paso más.
      </p>

      {error && <p className="form-mensaje error">{error}</p>}

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <div className="form-group">
          <label className="form-label">Código de Activación</label>
          <input
            type="text"
            className="form-input"
            placeholder="El código que te dio tu administrador"
            value={codigoActivacion}
            onChange={(e) => setCodigoActivacion(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="form-button" disabled={loading}>
          {loading ? 'Verificando...' : 'Activar Cuenta'}
        </button>
      </form>

      <button
        onClick={handleLogout}
        className="link-button"
        style={{ marginTop: '15px', color: '#666' }}
      >
        Cerrar Sesión / Cancelar
      </button>


    </div>
  );
}

export default CompletarRegistroScreen;
